module.exports = __webpack_public_path__ + "Banner_ModuleWrapup-8e4579846e3abe668d2b21c069d08176.svg";